import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-elem-info car" }
const _hoisted_2 = { class: "col-icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "col-info" }
const _hoisted_5 = { class: "ft-bold" }
const _hoisted_6 = { class: "ib val" }
const _hoisted_7 = { class: "ib val mr4" }
const _hoisted_8 = { class: "ib val" }
const _hoisted_9 = { class: "ib val" }
const _hoisted_10 = { class: "ib val" }

import { computed } from 'vue';
import type { MapElemInfo } from 'src/models';
import type { GICar } from 'src/models/geoItem';
import { carKindsWithSpecialImg } from 'src/consts/car_kinds_with_special_img';

interface Props {
  elem: MapElemInfo<GICar>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MapElemInfoCar',
  props: {
    elem: {}
  },
  setup(__props: any) {

const props = __props;

const car = computed<GICar>(() => props.elem.data);

const iconPath = computed<string>(() => {
  const carIconPrefix = '/static/img/car_';
  const statusPrefix = car.value.isMoving ? 'moving_' : 'stopped_';
  const imgCarKind = carKindsWithSpecialImg[car.value.device.carKind] || 'default';
  return `${carIconPrefix}${statusPrefix}${imgCarKind}.png`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "resource-icon",
        src: iconPath.value
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "ib lbl" }, "車両番号:", -1)),
        _createElementVNode("span", _hoisted_6, _toDisplayString(car.value.device.carName), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ib lbl" }, "所属:", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(car.value.device.groupInfo.g2name), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(car.value.device.groupInfo.g3name), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ib lbl" }, "状態:", -1)),
        _createElementVNode("span", _hoisted_9, _toDisplayString(car.value.statusDisp), 1)
      ]),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ib lbl" }, "車種:", -1)),
        _createElementVNode("span", _hoisted_10, _toDisplayString(car.value.device.carKindDisp), 1)
      ])
    ])
  ]))
}
}

})